export { default as Template } from './screens/Template';
export { default as UpdateTemplate } from '@/modules/templates/screens/UpdateTemplate';